<template>
    <transition>
        <router-view/>
    </transition>
</template>
<script>
export default {
    name:'itil-layout'
}
</script>